import type { HTMLAttributes, ReactNode } from "react";
import { cn } from "../../utils";

export interface PageLayoutProps extends HTMLAttributes<HTMLDivElement> {
  header?: ReactNode;
}

export function PageLayout({
  header,
  className,
  children,
  ...props
}: PageLayoutProps) {
  return (
    <div
      className={cn("w-full min-w-0 max-w-full space-y-section", className)}
      {...props}
    >
      {header}
      {children}
    </div>
  );
}
